






import { MyNav } from '../mynavbar/mynavbar'
import './newsupdates.css'

export function NewsUpdates() {

    return (<div className="body">
        <MyNav/>
        <div id="news" className="news-section">
            <h2 className="news-header" variant="h6">
                NEWS
            </h2>

            <div className="news-entry"><div><span className="news-entry-date">
                5-17-2021
                </span><span className="news-entry-title">
                Automation node buff
                </span></div><div className="news-entry-content">
                Automation nodes now have "latch" knobs, and can be snapped to different subdivisions.
            </div></div>

            <div className="news-entry"><div><span className="news-entry-date">
                4-23-2021
                </span><span className="news-entry-title">
                WAV export
                </span></div><div className="news-entry-content">
                Sound from NUNISYNTH can be exported to WAV now!
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                4-22-2021
                </span><span className="news-entry-title">
                MIDI Import
                </span></div><div className="news-entry-content">
                The Sample Pianoroll Node can now load imported MIDI data!
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                4-18-2021
                </span><span className="news-entry-title">
                Automatic Updates
                </span></div><div className="news-entry-content">
                NUNISYNTH now automatically updates to the latest version.
                We are almost ready to <span style={{color:'#300', fontWeight: 'bold' }}>release</span>❗<span
                style={{fontStyle:"italic"}}>❗</span>🎉
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                3-3-2021
                </span><span className="news-entry-title">
                Added the sample pianoroll node
                </span></div><div className="news-entry-content">
                We can now arrange multiple simultaneous samples of varying pitches
                within the sample pianoroll node!
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                2-2-2021
                </span><span className="news-entry-title">
                Updated the connection-type prompt
                </span></div><div className="news-entry-content">
                A bug was discovered with the connection type prompt 
                that would lock users out of the graph, so we fixed it
                and improved the look of it at the same time.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                2-1-2021
                </span><span className="news-entry-title">
                Rewrote the pianoroll editor
                </span></div><div className="news-entry-content">
                We rewrote the pianoroll editor (currently only
                being used by the Mono Pianoroll). With this rewrite, 
                we fixed bugs, made it more efficient, 
                made it more robust, and added new 
                features (flexible timebase & snap-to-grid toggle).
                But more importantly, it can now be used as a base
                for future nodes. Stay tuned!
            </div></div>
            
            <div className="news-entry"><div><span className="news-entry-date">
                1-20-2021
                </span><span className="news-entry-title">
                Time domain visualizer
                </span></div><div className="news-entry-content">
                Previously, the visualizer was only able to view 
                the frequency spectrum of the audio. Now we also
                have the option to view the time domain.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                1-13-2021
                </span><span className="news-entry-title">
                Volume level slider added to some nodes
                </span></div><div className="news-entry-content">
                Gain nodes are something that you'll always need in
                every project. Adding a volume level slider to some of
                the nodes (oscillator, sample, sequencers), however,
                reduces the need for gain nodes.
            </div></div>
            
            <div className="news-entry"><div><span className="news-entry-date">
                1-10-2021
                </span><span className="news-entry-title">
                Keyboard nodes have their own ADSR now
                </span></div><div className="news-entry-content">
                The "keyboard" nodes we're talking about here are
                the oscillators and samples, of course. So now when
                you decide to turn on "keyboard mode" for these,
                you'll be able to edit its' own local envelope/ADSR.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                1-6-2021
                </span><span className="news-entry-title">
                Waveform zooming
                </span></div><div className="news-entry-content">
                Now we can zoom deeply into the waveforms of sample nodes using the mouse scrollwheel.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                1-4-2021
                </span><span className="news-entry-title">
                macOS path bug
                </span></div><div className="news-entry-content">
                There was a bug that wouldn't allow macOS users
                to save their projects due to the macOS paths
                being treated the same as Windows paths. 
                Now we fixed it. :)
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                12-29-2020
                </span><span className="news-entry-title">
                Cross-sample formulas
                </span></div><div className="news-entry-content">
                Now you can reference and mix other samples within
                your sample formulas to do interesting things.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                12-24-2020
                </span><span className="news-entry-title">
                Sample imports
                </span></div><div className="news-entry-content">
                Now we can import mp3 or wav samples directly from the
                filesystem using the "import" button in the sample
                page.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                12-15-2020
                </span><span className="news-entry-title">
                Replaced emojis with SVGs
                </span></div><div className="news-entry-content">
                Previously, each node's icon was an emoji.
                Upon seeing that some of the emojis didn't work
                on macOS, we switched to SVG.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                12-6-2020
                </span><span className="news-entry-title">
                Autiomation freehand mode
                </span></div><div className="news-entry-content">
                Now we can click the pencil icon within the
                automation node to freehandedly draw our automation
                curves. If too many points lie close to the same line,
                some of them are removed, for optimization purposes.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                12-5-2020
                </span><span className="news-entry-title">
                Mouse disappears when dragging knobs now
                </span></div><div className="news-entry-content">
                Why is this news? Because it ended up being a
                rather nice UI improvement, actually. The thing is,
                knobs respond to being dragged up or down.
                Normally, the user would try to make a circle around
                the knob with the cursor, and then be a little
                confused that it didn't rotate how they thought
                it would. But if we hide the cursor while rotating
                the knob, the up-and-down movement, all of a
                sudden, feels a lot more natural.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                12-4-2020
                </span><span className="news-entry-title">
                Autiomation node transform functions
                </span></div><div className="news-entry-content">
                Now, when you select a group of automation points,
                you'll see a green, cyan, yellow, and red circle.
                You can drag either of these to transform the 
                set of selected points.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                11-30-2020
                </span><span className="news-entry-title">
                Versatile number components
                </span></div><div className="news-entry-content">
                The sequencers now have what we call "versatile number
                components", that can switch between a discrete knob
                (that scrolls through a list of different subdivisions),
                and a continuous knob. So "phasing" is now possible.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                11-26-2020
                </span><span className="news-entry-title">
                Automation nodes
                </span></div><div className="news-entry-content">
                We can now use automation nodes.
                They're similar to Gate sequencers, but only allow one
                channel. You can draw automation lines/curves to
                open and close the signal. Basically, you draw the
                envelope.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                11-14-2020
                </span><span className="news-entry-title">
                Local ADSR for sequencers
                </span></div><div className="news-entry-content">
                Previously, the sequencers were forced to share
                4 ADSRs. Now they can each have their own.
            </div></div>
            
            <div className="news-entry"><div><span className="news-entry-date">
                11-1-2020
                </span><span className="news-entry-title">
                Fixed sequencer UI jiggle
                </span></div><div className="news-entry-content">
                The UI of sequencers was jiggling a bit while
                they were playing. Now that's gone.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                10-27-2020
                </span><span className="news-entry-title">
                Processor node
                </span></div><div className="news-entry-content">
                Custom audio processing code can be input into
                Processor nodes via their code editors. 
                The possibilities here are great,
                and will take a while to explore.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                10-8-2020
                </span><span className="news-entry-title">
                Sample loopstart and loopend
                </span></div><div className="news-entry-content">
                Sample nodes now allow you to "slice" the sample
                to specified start and end times. As a bonus,
                making moving the loopend before the loopstart 
                reverses the current section of the sample.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                9-20-2020
                </span><span className="news-entry-title">
                Desktop recording
                </span></div><div className="news-entry-content">
                You can now record your own desktop audio into
                a sample node. You can play your favorite YouTube
                video in the background and record part of it into 
                a sample, for example.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                9-16-2020
                </span><span className="news-entry-title">
                Mono Pianoroll node
                </span></div><div className="news-entry-content">
                Mono Pianoroll nodes are meant to be connected to the 
                detune parameter of nodes that have a detune 
                parameter (Oscillator, Sample, Sample Sequencer, 
                Filter). It's somewhat limited, but can still
                produce some cool results.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                9-9-2020
                </span><span className="news-entry-title">
                Basic support for themes
                </span></div><div className="news-entry-content">
                Now we have more than just the standard dark mode.
                Nice!
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                8-20-2020
                </span><span className="news-entry-title">
                Node insertion macro
                </span></div><div className="news-entry-content">
                For convenience, we added the ability to "insert"
                nodes (those with a <code>channel</code> property)
                into connections.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                8-9-2020
                </span><span className="news-entry-title">
                Sequencer solo channel
                </span></div><div className="news-entry-content">
                Sequencer channels can be soloed now.
            </div></div>
            
            <div className="news-entry"><div><span className="news-entry-date">
                8-6-2020
                </span><span className="news-entry-title">
                Added subdivision options to oscillator
                </span></div><div className="news-entry-content">
                Oscillators can set to subdivision LFO frequencies
                from a dropdown list. They can't be synced
                to the clock, but at least they can have a
                proper subdivision. Delay nodes can too, but
                they'll be clamped to 1 second.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                8-3-2020
                </span><span className="news-entry-title">
                Added step shift to sequencers
                </span></div><div className="news-entry-content">
                Because why not? It's yet another way to twist
                things a bit. Happy Birthday, Marlon!
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                7-30-2020
                </span><span className="news-entry-title">
                Modularize function
                </span></div><div className="news-entry-content">
                We can press "Modularize" in the edit menu now
                to encapsulate the entire graph into a single module.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                7-19-2020
                </span><span className="news-entry-title">
                Sequencer phase shift
                </span></div><div className="news-entry-content">
                Now sequencers can be phase shifted, so you can play
                with swinging them now.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                7-16-2020
                </span><span className="news-entry-title">
                Updated graph operations
                </span></div><div className="news-entry-content">
                Along with "normal" copying (with <code>ctrl + c </code>
                and <code>ctrl + click</code>), 
                you can now press <code>ctrl + s</code> while nodes 
                are selected to copy them and their "outer"
                connections (connections to nodes that aren't selected)
                in place.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                7-7-2020
                </span><span className="news-entry-title">
                Optimized visualizer
                </span></div><div className="news-entry-content">
                The visualizer now successfully runs on a separate
                thread. Hooray!
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                6-25-2020
                </span><span className="news-entry-title">
                Added Module nodes
                </span></div><div className="news-entry-content">
                These are nodes that can hold yet more nodes inside.
                There is no limit to how many nested modules you can have.
                These are useful for creating your own reusable nodes,
                or even just tidying up your graph a bit. This one was
                quite a bit of work.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                6-18-2020
                </span><span className="news-entry-title">
                Added Recorder nodes
                </span></div><div className="news-entry-content">
                Now you can create a recorder node, connect something
                to it, and record the audio to a specified sample.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                6-15-2020
                </span><span className="news-entry-title">
                Added visualizer
                </span></div><div className="news-entry-content">
                We added a nice visualizer so that you can see what your
                sound looks like. It also turns red when the audio 
                clips, which is a nice feature to have.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                6-11-2020
                </span><span className="news-entry-title">
                Added Number Value Nodes
                </span></div><div className="news-entry-content">
                Number value nodes are very simple, yet useful nodes.
                What's special about them is that we can use them
                to change the values of multiple nodes, simultaneously.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                6-9-2020
                </span><span className="news-entry-title">
                Added Sample Sequencer 
                </span></div><div className="news-entry-content">
                It's like the Gate Sequencer, but it lets you choose
                the samples and number of rows from within the node
                itself, instead of from its' inputs. It can still 
                take inputs to automate the detune or playback rate of the
                sequencer as a whole.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                5-29-2020
                </span><span className="news-entry-title">
                Added Gate Sequencer 
                </span></div><div className="news-entry-content">
                It's a node that makes a sequence from its' inputs.
                We can have as many of them as we want, with different
                numbers of steps and subdivisions, allowing for some
                pretty interesting rhythmic possibilities.
            </div></div>
            
            <div className="news-entry"><div><span className="news-entry-date">
                5-25-2020
                </span><span className="news-entry-title">
                Multiple node windows can be opened
                </span></div><div className="news-entry-content">
                Like the title says - multiple node windows can
                be opened simultaneously. And that's more convenient.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                5-14-2020
                </span><span className="news-entry-title">
                Added Sample Generator
                </span></div><div className="news-entry-content">
                Samples can now be generated via a JavaScript formula,
                or recorded from the graph itself.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                5-2-2020
                </span><span className="news-entry-title">
                Added Scale Builder
                </span></div><div className="news-entry-content">
                We now have three main ways to build exotic scales.
                We can choose any EDO (equal division of octave)
                we want, including non-integer EDOs. We can also generate
                scales from a JavaScript formula, or from a mixed list of
                detune values and JI (just intonation) ratios.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                4-17-2020
                </span><span className="news-entry-title">
                UI updates
                </span></div><div className="news-entry-content">
                Moved the "Create New Node" buttons to a contextmenu that spawns
                when you right click on the graph. Improved the number 
                inputs so that you can drag the current value up 
                or down as well as typing it in.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                4-13-2020
                </span><span className="news-entry-title">
                Improved polyphony II
                </span></div><div className="news-entry-content">
                Bugs were caused by: 1. changing the current
                scale while playing the keyboard and 2. by changing
                samples while playing the keyboard. Now those bugs 
                no longer exist.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                4-10-2020
                </span><span className="news-entry-title">
                Improved polyphony
                </span></div><div className="news-entry-content">
                There were some performance issues that would
                cause audio to drop out when using a low number
                of sample/oscillator nodes in polyphonic-keyboard
                mode, and now they are solved.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                4-7-2020
                </span><span className="news-entry-title">
                Added ADSR envelopes
                </span></div><div className="news-entry-content">
                Users can now edit the shape of the envelope that 
                the keyboard triggers.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                4-5-2020
                </span><span className="news-entry-title">
                Keyboard can trigger samples
                </span></div><div className="news-entry-content">
                We can now use the keyboard and select a scale to
                polyphonically trigger samples with.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                4-3-2020
                </span><span className="news-entry-title">
                Added the Sample Node
                </span></div><div className="news-entry-content">
                Sample nodes just hold samples that loop.
                You can detune it or change the playback rate
                (it's actually the same thing, just on different scales).
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                3-27-2020
                </span><span className="news-entry-title">
                Added basic functionality
                </span></div><div className="news-entry-content">
                Nodes can be dragged around and connected to each other.
                The graph structure can be saved.
            </div></div>
    
            <div className="news-entry"><div><span className="news-entry-date">
                3-24-2020
                </span><span className="news-entry-title">
                Wrote the first line of code
                </span></div><div className="news-entry-content">
                NUNISYNTH began as an exploration tool to learn about modular synthesis.
            </div></div>
        </div>
    </div>)    
}